export default "__VITE_ASSET__BdgQIq6v__"